import React from "react";
import { Grid, Typography } from "@material-ui/core";
import styled from "styled-components";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import * as PropTypes from "prop-types";

export const GrowDiv = styled.div`flex-grow: 1`;

const labels = {
  ownedGames: "Owned games",
  playedGames: "Played games",
  neverPlayedGames: "Never played games",
  wantToPlay: "Want to play",
  totalGamingHours: "Total gaming hours",
  avgGamingHours: "Average hours per game",
  medianGamingHours: "Median hours per game",
  perfectAchievements: "Perfect achievements",
};
const mapLabelsWithData = (data) => {
  const merged = [];
  Object.entries(data).forEach(([key, value]) => {
    merged.push([labels[key], value]);
  });
  return merged;
};

const AccountStats = ({ accountStats }) => {
  const uiReadyAccountStats = mapLabelsWithData(accountStats);
  const fullLength = uiReadyAccountStats.length;
  const halfLength = Math.floor(fullLength / 2);

  return (
    <>
      <Typography component="h2" variant="h6">Account Stats</Typography>

      <Grid container
            spacing={0}
            direction="row"
            wrap="wrap"
            alignItems="flex-start"
            justify="space-evenly">
        <Grid item xs={12} sm={6} md={6}>
          <List component="ul">
            {uiReadyAccountStats.slice(0, halfLength).map((element) => (
              <ListItem component="li" divider key={element[0]}>
                <Typography variant="body1">{element[0]}</Typography>
                <GrowDiv />
                <Typography variant="body1" color="secondary">{element[1]}</Typography>
              </ListItem>
            ))}
          </List>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <List component="ul">
            {uiReadyAccountStats.slice(halfLength, fullLength).map((element) => (
              <ListItem component="li" divider key={element[0]}>
                <Typography variant="body1">{element[0]}</Typography>
                <GrowDiv />
                <Typography variant="body1" color="secondary">{element[1]}</Typography>
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </>
  );
};
AccountStats.propTypes = {
  accountStats: PropTypes.object.isRequired,
};

export default AccountStats;
